import { render, staticRenderFns } from "./HomeSocialProof.vue?vue&type=template&id=3735d143"
import script from "./HomeSocialProof.vue?vue&type=script&lang=js"
export * from "./HomeSocialProof.vue?vue&type=script&lang=js"
import style0 from "./HomeSocialProof.vue?vue&type=style&index=0&id=3735d143&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InstagramLogo: require('/app/components/InstagramLogo.vue').default,InstagramStoriesViewer: require('/app/components/InstagramStoriesViewer.vue').default})
